export default {"src":"/_next/static/media/ADI.5adaad57.svg","height":18,"width":18};